import './component.scss'
import '@splidejs/splide/css';
import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function() {
  if (document.getElementById('company-mv-image-carousel') !== null) {
    const splide = new Splide('.splide#company-mv-image-carousel', {
      type: 'loop',
      pagination: false,
    }).mount();
    splide.on("active", function () {
      slideIndex();
    });
    function slideIndex() {
      // 現在のスライドが何枚目かを取得
      document.getElementById("slide-current").textContent = splide.index + 1;
      // スライドの総数を取得
      document.getElementById("slide-length").textContent = splide.length;
    }
    slideIndex();
  }
})
